import React from 'react';
import moment from 'moment';
import {
    Typography,
    Box
} from '@mui/material';

const MarkaazBusinessComponent = ({ details }) => {
    return (
        <Box display={'flex'} gap='7px' alignItems='baseline'>
            <Box display='flex' flexDirection='column'>
                <Typography className='py-1' variant='body2' ><b>Account Type:</b> Business</Typography>
                <Typography className='py-1' variant='body2' ><b>Member Since: </b>{moment(details.claimedAt).format('MM/DD/YYYY')}</Typography>
            </Box>
        </Box>
    )
};

export default MarkaazBusinessComponent;